<template>
  <div>
    <p>You're looking for a really low cost purifier, so our DIYs are your best option. Since you have a big space, your may need to get creative to clean it all:</p>
    <h4>Double (or triple) up on purifiers!</h4>
    <p>If you get yourself 2-3 <router-link to="purifiers/diy11">DIY1.1s</router-link>, or 2-3 <router-link to="purifiers/cannon">Cannons</router-link>, you can cover 2-3 times the area!</p>

    <h4>Spend a little extra</h4>
    <p>The <router-link to="purifiers/blast">Blast</router-link> and <router-link to="purifiers/blastmini">Blast Mini</router-link> are even more cost-effective than the DIYs, so if you can spend the little extra, you can get something with much higher performance that's also much quieter. Oh, and they're still a lot cheaper than most purifiers out there.</p>
</div>
</template>

<script>
import {all} from '@/data/purifiers.js'
import PurifierImage from '@/components/PurifierImage'

export default {
  name: 'Noise',
  components: {PurifierImage},
  props: ['id'],
  computed: {
    purifier: function () {
      console.log(this.id)
      var a = all.filter((i) => {
        return i.id === this.id
      })[0]
      console.log(a)
      return a
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
a h1, a h2, a:hover {
  text-decoration:none;
  color: #2c3e50;
}
img.purifier_img {
  max-width:200px;
}
.backbutton {
  text-align:left;
}
.purifierinfo {
  max-width:400px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/LowCostView.vue